module.exports = __webpack_public_path__ + "img/cs.43f56cd4.svg";